<div class="login-page w-100">
  <div class="login-wrapper d-flex flex-column align-items-center justify-content-center h-100">
    <div class="logo d-flex flex-column align-items-center justify-content-center text-center">
      <img src="assets/smata-shared/Smata.png" alt="Strata Space" />
    </div>
    <div class="login-card d-flex flex-column align-items-center gap-3">
      <h2 class="text-center fw-semibold">Log In to Review Invoices</h2>
      <div class="form-container d-flex flex-column w-100">
        <smata-single-input label="Email or mobile number" [formControl]="formControl.identifier">
          @if (formControl.identifier.touched && formControl.identifier.hasError('required')) {
            <mat-error> Email or mobile number is required. </mat-error>
          }
        </smata-single-input>
        <p class="hint small mb-3">We will send a passcode to your email or mobile number.</p>
        <button smataClientNgBtn class="btn btn-primary fw-semibold" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
